// @flow
import type { Action } from '../types';
import type { AppRenderData } from '../types/app_render';

export default (state: AppRenderData = {}, action: Action): AppRenderData => {
    switch (action.type) {
        case 'CHANGE_APP_RENDER':
            return changeAppRenderSettings(state, action)
        default:
            return state;
    }
};

function changeAppRenderSettings(state, action) {
    
    if(action.setting_type === 'wishlist') {
        return {
            ...state,
            wishlist_settings: action.payload
        }
    } else if(action.setting_type === 'compare') {
        return {
            ...state,
            compare_settings: action.payload
        }
    } 
    else if(action.setting_type === 'general') {
        return {
            ...state,
            general_settings: action.payload
        }
    } 
}
